import ReactSelect from 'react-select'

export default ReactSelect
